var _rect, _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30_2292)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_30_2292",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: -1,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.75,
    y: -0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_30_2292)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.26953 4.99023C5.26953 4.76905 5.18167 4.55692 5.02526 4.40052C4.86886 4.24412 4.65673 4.15625 4.43555 4.15625C4.21436 4.15625 4.00223 4.24412 3.84583 4.40052C3.68943 4.55692 3.60156 4.76905 3.60156 4.99023V19.3348C3.60156 19.7329 3.75972 20.1147 4.04125 20.3963C4.32277 20.6778 4.7046 20.8359 5.10273 20.8359H19.4473C19.6685 20.8359 19.8806 20.7481 20.037 20.5917C20.1934 20.4353 20.2812 20.2231 20.2812 20.002C20.2812 19.7808 20.1934 19.5686 20.037 19.4122C19.8806 19.2558 19.6685 19.168 19.4473 19.168H5.26953V4.99023ZM20.0369 8.9158C20.1888 8.75851 20.2729 8.54784 20.271 8.32917C20.2691 8.11051 20.1814 7.90133 20.0267 7.7467C19.8721 7.59208 19.6629 7.50437 19.4443 7.50247C19.2256 7.50057 19.0149 7.58463 18.8576 7.73655L13.6094 12.9848L10.8631 10.2385C10.7067 10.0822 10.4946 9.99432 10.2734 9.99432C10.0523 9.99432 9.84021 10.0822 9.68381 10.2385L6.34787 13.5744C6.26822 13.6514 6.20468 13.7434 6.16098 13.8451C6.11727 13.9469 6.09426 14.0563 6.0933 14.1671C6.09234 14.2778 6.11344 14.3876 6.15537 14.4901C6.1973 14.5926 6.25923 14.6857 6.33754 14.764C6.41584 14.8423 6.50896 14.9043 6.61145 14.9462C6.71394 14.9881 6.82376 15.0092 6.9345 15.0083C7.04523 15.0073 7.15467 14.9843 7.25642 14.9406C7.35817 14.8969 7.45019 14.8333 7.52713 14.7537L10.2734 12.0074L13.0197 14.7537C13.1761 14.91 13.3882 14.9979 13.6094 14.9979C13.8305 14.9979 14.0426 14.91 14.199 14.7537L20.0369 8.9158Z",
    fill: "#2D323E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30_2292"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard-icon.aa9e08457377d2a1b21918ef527e9d57.svg";
export { ForwardRef as ReactComponent };